import { ErrorMessage } from 'components/TextInput'
import { Ref, forwardRef, useContext } from 'react'
import AsyncSelect from 'react-select/async'
import AsyncSelectCreatable from 'react-select/async-creatable'
import { ThemeContext } from 'styled-components'

import { IndicatorsContainer, Option, OptionLeadMerge } from './custom'
import { DropdownContainer, LabelText, RequiredText } from './styles'
import { AsyncDropdownProps, DropdownItem } from './types'
import variants from './variants'
import { GroupBase } from 'react-select'
import Select from 'react-select/dist/declarations/src/Select'

const AsyncDropdown = forwardRef<HTMLInputElement, AsyncDropdownProps>(
  (
    {
      error,
      inline,
      isCreatable = false,
      label,
      required,
      showError = true,
      variant = 'simple',
      width = 'auto',
      isSearchOption = false,
      showIcon = true,
      ...props
    },
    ref,
  ) => {
    const Component = isCreatable ? AsyncSelectCreatable : AsyncSelect
    const theme = useContext(ThemeContext)
    const variantStyles = variants[variant]

    return (
      <DropdownContainer width={width}>
        {variant === 'labeled' && (
          <LabelText disabled={props.isDisabled}>
            {label}
            {required && <RequiredText>*</RequiredText>}
          </LabelText>
        )}
        <Component
          {...props}
          ref={ref as Ref<Select<DropdownItem<string>, false, GroupBase<DropdownItem<string>>>>}
          components={{
            IndicatorsContainer: (p) => IndicatorsContainer(p, showIcon),
            Option: isSearchOption ? OptionLeadMerge : Option,
          }}
          menuPortalTarget={document.body}
          styles={{
            ...variantStyles({ inline, variant, width, theme, error }),
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
        />
        {error && showError && <ErrorMessage>{error}</ErrorMessage>}
      </DropdownContainer>
    )
  },
)

export default AsyncDropdown
